<template>
    <div id="payment">
        <div class="header2">
            <div class="header2Wrap">
                <div class="header2L">
                    <img src="@/assets/list/logo.png" alt />
                </div>
                <!-- <p class="button1">
                    <i class="fa fa-reply" aria-hidden="true"></i>
                    <span>返回商城</span>
                </p> -->
            </div>
        </div>
        <!-- 主体 -->
        <div class="main">
            <div class="mainTop">
            </div>
            <div class="mainTop2">
                <p class="mainTop21">支付方式：</p>
                <el-radio-group v-model="radio"  @change="selectwxzfb">
                    <el-radio :label="1">
                        <img src="@/assets/list/wei.png" alt />
                    </el-radio>
                    <el-radio :label="2">
                        <img src="@/assets/list/zhi.png" alt />
                    </el-radio>
                    <!-- <el-radio :label="3">
                        <img src="@/assets/list/wei.png" alt />
                    </el-radio> -->
                    <!-- <el-radio :label="4">
                        <img src="@/assets/list/zhi.png" alt />
                    </el-radio> -->
                    <el-button type="info" size="small" @click="back()" class="grey">取消</el-button>
                    <el-button type="danger" @click="fetchVideoPay()" size="small" class="red">立即支付</el-button>
                </el-radio-group>
                 </div>
                <div class="mains">
                     <!-- 微信支付 -->
                <div id="zzqrcode1" v-if="radio == '1'"></div>
                <!-- 支付宝支付 -->
                <iframe name="zfbFrom" src v-if="radio == '2'" class="zfbClass" ></iframe>
                   <!-- 银联微信支付 -->
                   <!-- <div id="ylCode" v-if="radio>2">
                        <img id="ylCodeImg" src alt="支付二维码">
                   </div> -->
                   <!-- 银联支付宝支付 -->
                   <!-- <iframe name="ylCode" :src="iframeSrc" v-if="radio >2" class="zfbClass" ></iframe> -->
                   <!-- <a href="https://qragateway.95516.com/m/showQr?code=https%3A%2F%2Fqr.95516.com%2F00010048%2FunifiedNative%3Ftoken%3Dde92fdea840ac9495b8dfd4777717449%26target%3Dqfs%26unit%3Dshw1">hhhhhhhhh</a> -->
                </div>
               
           

            <!--<div class="content">
                 <div class="content1">
            <el-radio-group v-model="radio1" class="radioWidth">
              <el-radio :label="3" class="radioWidth2">
                  <img src="@/assets/list/hua.png" alt="" class="content1-1">
                  <p class="content1-2">推荐</p>
                  <p class="content1-3">
                      <span class="tits1">支付</span>
                      <span class="moneys1">￥270.00</span>
                  </p>
              </el-radio>
          </el-radio-group>
           <el-radio-group v-model="radio1" class="radioWidth">
              <el-radio :label="3" class="radioWidth2">
                  <img src="@/assets/list/hua.png" alt="" class="content1-1">
              </el-radio>
          </el-radio-group>
                </div>-->
                <!-- <div id="qrcode"></div> -->
                <!-- <div class="content2">
               <p class="content2-1">
                   <span>其它付款方式</span>
                   <span>添加快捷/网银付款</span>
               </p>
                <div v-html="html"></div>
               <p class="content2-2">
                   <i></i>
                   <span>安全设置检测成功！无需短信校验</span>
               </p>
               <p class="content2-3">支付宝支付密码：</p>
               <p class="content2-4">
                   <input type="text"/>
                   <span>忘记密码？</span>
               </p>
               <p class="content2-5">请输入6位数字支付密码 </p>
                </div>-->
                <!-- <div class="content3">
                    <p @click="fetchVideoPay()">确认付款</p>
                </div>
            </div> -->
            <div id="qrcode"></div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode-generator';
// new QRCode(document.getElementById("qrcode"), "http://www.runoob.com");
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";

export default {
    name: "Shopping",
    data() {
        return {
            userId: "",
            checked: true,
            value1: null,
            desc: "",
            radio: 0,
            html: "",
             paytimer: 300 ,//300秒，5分钟
             iframeSrc:''
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
            this.getData();
        }
        // console.log(this.$route.query.id);
        // console.log(this.$route.query.money);
        //要跳到推荐页面
        // console.log(this.$route.query.name);
        // console.log(this.$route.query.medId);
    },
    beforeRouteLeave(to, from, next) {
         // 判断是否是浏览器返回按钮触发的路由离开
       if(to.path=="/ReceivingAddress"){
        sessionStorage.setItem("leftIndex2", 1);
        this.$router.push({ path: "/myOrder"});
       }else{
        next();
       }
   
  },
    methods: {
        back(){//取消支付
             this.$confirm("您还未支付，是否取消", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
                }).then(() => {
                    this.radio = "";
                    this.payFinish = true;
                    sessionStorage.setItem("leftIndex2", 1);
                    this.$router.push({ path: "/myOrder"});
                // this.$router.go(-1)
                });
        },

        getData() {
            var params = {};
            params.id = this.$route.query.id;
            params.atZffs = this.radio;
            let url = "/wx/pay/unifiedorder";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                }
            });
        },
         //选择微信支付还是支付宝支付
        selectwxzfb() {
            if(this.radio>2){
                this.ylPay()
            }else{
                this.fetchVideoPay()
            }
            
        },
        fetchVideoPay() {
            if(!this.radio){
                  this.$message.error("请您先选择支付方式");
                  return false
            }
            var params = {};
            params.id = this.$route.query.id;
            params.atZffs = this.radio;
            let url = "/wx/pay/unifiedorder";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    if (this.radio == 1) {
                          document.getElementById("zzqrcode1").innerHTML = "";
                        //微信支付
                        console.log(res.data.data.orderStr)
                        // new QRCode(
                        //     document.getElementById("zzqrcode1"),
                        //    "https://www.baidu.com/"
                        // );
                        // new QRCode(document.getElementById("zzqrcode1"), "https://example.com");
                         const container = document.getElementById("zzqrcode1");
                            // 清空容器
                            container.innerHTML = '';
                            // 生成二维码
                            const qr = QRCode(8, 'M'); // TypeNumber: 4, ErrorCorrectionLevel: 'M'
                            qr.addData(res.data.data.orderStr);
                            qr.make();
                            // 将二维码插入容器
                            container.innerHTML = qr.createImgTag(); // 生成 <img> 标签

                    } else {
                        //支付宝支付
                        const div = document.createElement("div");
                        div.innerHTML = res.data.data.orderStr; // 接口返回的form 表单字符串
                        document.body.appendChild(div);
                        // document.forms[4].acceptCharset = "UTF-8"; //如果后台返回form的charset=GBK，需要做此修改
                        document.forms[document.forms.length - 1].submit();
                    }
                     this.getPayStatus();
                }
            });
        },
        ylPay(){
            let that = this;
            if(!this.radio){
                  this.$message.error("请您先选择支付方式");
                  return false
            };
            var params = {};
            params.id = this.$route.query.id;
            params.atZffs = 6;
            let url = "/unionPay/goPay";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    const newPageUrl = res.data.data.code_img_url; 
                    window.open(newPageUrl, '_blank');
                        //银联支付宝微信支付
                    //    const qrCodeUrl =res.data.data.code_img_url;
                    //     const qrCodeImg = document.getElementById('ylCodeImg');
                    //     if (qrCodeImg) {
                    //         qrCodeImg.src = qrCodeUrl;
                    //         that.iframeSrc = qrCodeUrl;
                    //     }
                    // document.getElementById("ylCode").innerHTML = "";
                    //     //微信支付
                    //     new QRCode(
                    //         document.getElementById("ylCode"),
                    //         res.data.data.code_url
                    //     ); // 设置要生成二维码的链接
                    //  this.getPayStatus();
                }
            });
        },
        // 判断是否支付成功的回调
        getPayStatus() {
            let that = this;
            let payFinish = false;
            if (that.paytimer == 0) {
                that.$message.error("您在五分钟之内未支付，请支付");
                that.paytimer = 300;
                return false;
            }
            if (payFinish) return false;
            let url = "/ddgl/getDdglByState";
            var params = {};
            params.id = this.$route.query.id;
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.paytimer = that.paytimer - 5;
                        if (res.data.optDdzt == "0") {
                            // 未付款
                                setTimeout(that.getPayStatus, 5000);
                            console.log(that.paytimer);
                        } else if(res.data.optDdzt == "1"){
                             //已取消
                              //失败
                            payFinish = true;
                             that.$message({
                                message: '订单超时！',
                                type: "warning"
                            });
                            this.$router.go(-1)
                        }else if (res.data.optDdzt == "7") {
                           //已退款
                            //失败
                            payFinish = true;
                            
                            that.$message({
                                message: '您的订单已自动退款，请联系客服人员',
                                type: "warning"
                            });
                           
                        } else {
                            payFinish = true;
                            that.$message({
                                message: "支付成功",
                                type: "success"
                            });
                             sessionStorage.setItem("leftIndex1", 100); //左侧导航位置
                            sessionStorage.setItem("leftIndex2", 1); //左侧导航位置第二组第二个
                            sessionStorage.setItem("leftIndex3", 100); //左侧导航位置
                            that.$router.replace({path: "/myOrder"});
                        }
                    } else {
                        if(res.msg !="订单id不能为空")
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },






        //   okFryOtherPayHandler(){
        //     var params = {};
        //     params.id = this.$route.query.id;
        //     params.atZffs =this.radio;
        //     let url = "/wx/pay/unifiedorder";
        //    this.$http.post(url, params).then(res => {
        //       let resData = res.data.data;
        //       if (res.data.code == 200) {
        //         document.querySelector('#submitFormDiv').innerHTML = resData.orderStr;
        //         this.executeScript(resData.orderStr);
        //       }else{
        //         this.submitActive = false;
        //         Toast({
        //           message: resData.respHeader.message,
        //         });
        //       }
        //      });
        //   },
        //   executeScript(html){
        //     let reg = /<script[^>]*>([^\x00]+)$/i;
        //     let htmlBlock = html.split("<\/script>");
        //     for (let i in htmlBlock){
        //       let blocks;
        //       if (blocks = htmlBlock[i].match(reg)){
        //         let code = blocks[1].replace(/<!--/, '');
        //         try{
        //           eval(code) //执行脚本
        //         }
        //         catch (e){
        //         }
        //       }
        //     }
        //   },
    },
};
</script>
<style scoped>
.main {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.header2 {
    width: 100%;
    height: 94px;
    background-color: #f64420;
}
.header2Wrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.header2L {
    width: 280px;
    height: 90%;
    padding-top: 10px;
}
.header2L img {
    width: 100%;
    height: 80%;
}
.button1 {
    float: right;
    width: 107px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    border-radius: 16px;
    border: solid 1px #ffffff;
    cursor: pointer;
    margin-top: 30px;
    opacity: 0.8;
}
.content {
    width: 100%;
}
.content::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}
.mainTop {
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 1px;
    color: #666666;
    margin-top: 30px;
}
.mainTopL {
    float: left;
    width: 75%;
}
.mainTopR {
    float: right;
    width: 25%;
}
.mainTopR p {
    float: left;
    height: 40px;
    line-height: 40px;
}
.mainTopR1 {
    margin-right: 20px;
}
.tits1 {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #999999;
}
.moneys1 {
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #f64420;
}
.mainTop2 {
    width: 100%;
    height: 77px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
}
.mainTop2 p {
    float: left;
    height: 77px;
    line-height: 77px;
    display: table-cell;
    margin-right: 40px;
}
.mainTop21 {
    margin-left: 20px;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #666666;
}
.mainTop2 img {
    vertical-align: middle;
}
.content {
    width: 100%;
    height: 584px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
}
.content1 {
    width: 100%;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 10px;
}
.content1::after {
    content: "";
    height: 0;
    clear: both;
    display: block;
    visibility: hidden;
    overflow: hidden;
}
.content1-1,
.content1-2,
.content1-3 {
    float: left;
}
.radioWidth {
    width: 100%;
    height: 72px;
    line-height: 52px;
    box-sizing: border-box;
    padding: 10px 40px;
    border: solid 2px #fcd4a0;
}
.radioWidth2 {
    width: 100%;
    height: 42px;
}
.radioWidth2 .content1-1 {
    display: block;
    margin-left: 10px;
}
.radioWidth2 .content1-2 {
    width: 30px;
    height: 16px;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 1px;
    color: #ffffff;
    background-color: #29ab91;
    margin-left: 30px;
}
.radioWidth2 .content1-3 {
    float: right;
}
.content2 {
    box-sizing: border-box;
    padding: 30px 20px;
    border-bottom: 1px dashed #ddd;
}
.content2-1 {
    height: 40px;
}
.content2-1 span {
    display: block;
    width: 170px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border: solid 1px #cccccc;
    text-align: center;
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: 600;
    color: #00a0e9;
    cursor: pointer;
    float: left;
    margin-right: 20px;
}
.content2-2 {
    width: 25%;
    height: 50px;
    line-height: 50px;
    color: #000;
    font-weight: 600;
    font-size: 14px;
    text-align: left !important;
}
.content2-3 {
    width: 25%;
    height: 30px;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    margin-top: 20px;
}
.content2-4 {
    width: 50%;
    height: 40px;
    margin: 10px 0;
}
.content2-4 input {
    display: block;
    float: left;
    width: 306px;
    height: 40px;
    font-size: 25px;
}
.content2-4 span {
    display: block;
    float: left;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #00a0e9;
    margin-left: 10px;
    cursor: pointer;
}
.content2-5 {
    clear: both;
    width: 25%;
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 1px;
    color: #999999;
    margin-top: 20px;
}
.content3 {
    margin-top: 20px;
}
.content3 p {
    margin-left: 20px;
    width: 170px;
    height: 40px;
    line-height: 40px;
    background-color: #f64420;
    font-size: 18px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
}
.mains{
    width:100%;
    height:400px;
    background:#fff;
    padding-top: 30px;
}
.zfbClass{
    width:70%;
    height:300px;
}
#zzqrcode1{
    margin-left:20px;
}
>>>#zzqrcode1 img{
    width: 200px!important;
    height: 200px!important;
}
</style>
<style>
#payment .el-radio-group {
    margin-top: 20px;
}
#payment .content1 .el-radio__input {
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/payment.vue